export default {"src":"/pro/_next/static/media/edge-logo.78055255.svg","height":25,"width":65,"blurWidth":0,"blurHeight":0};